import {
  GET_ENTITY_OWNERSHIP_EVENTS_REQUEST,
  GET_ENTITY_OWNERSHIP_EVENTS_SUCCESS,
  GET_ENTITY_OWNERSHIP_EVENTS_FAILURE,
  RESET_ENTITY_OWNERSHIP_CHART_DATA,
  statusType
} from '../../../actions'

const moment = require('moment-timezone')

/**
 * Entity Ownership Chart - Events Reducer
 * @param state
 * @param action
 * @returns
 * {
 *    [securityId]: {
 *      data: [],
 *      status: 'SUCCESS'
 *    },
 *    [securityId]: {
 *      data: [],
 *      status: 'SUCCESS'
 *    }
 * }
 */
const events = (state = {}, action) => {
  const { payload, request } = action

  switch (action.type) {
    case GET_ENTITY_OWNERSHIP_EVENTS_REQUEST:
      return {
        ...state,
        [payload.securityId]: {
          status: statusType.IN_PROGRESS
        }
      }

    case GET_ENTITY_OWNERSHIP_EVENTS_SUCCESS:
      return {
        ...state,
        [request.securityId]: {
          data: (payload || [])
            .filter((record) => record.date && record.title)
            .map((record) => ({
              x: moment.utc(record.date).valueOf(),
              title: ' ',
              text: record.title,
              id: record._id
            }))
            .reverse(),
          status: statusType.SUCCESS
        }
      }

    case GET_ENTITY_OWNERSHIP_EVENTS_FAILURE:
      return {
        ...state,
        [request.securityId]: {
          status: statusType.ERROR
        }
      }

    case RESET_ENTITY_OWNERSHIP_CHART_DATA:
      return {
        ...state,
        [payload.securityId]: undefined
      }

    default:
      return state
  }
}

export default events
